<template>
  <div :data-state="data.status" class="reg-input-parent">
    <div ref="labelRef" style="display: flex; justify-content: space-between;">
      <label ref="input" class="reg-label">
        {{ $t(data.labelKey) }}
      </label>
    </div>
    <div class="input-wrapper">
      <input
        @focus="sendToGA"
        :name="data.label"
        v-bind:value="data.text"
        v-on:input="
          reducer({
            event: data.label,
            payload: $event.target.value,
          })
        "
        @click="
          reducer({
            event: 'clicked',
            payload: data.label,
          })
        "
        :type="inputType()"
        class="reg-input"
        :autocomplete="
          data.label.startsWith('pass') ? 'new-password' : data.label
        "
      />
      <div v-if="icon" class="register-icon-wrapper">
        <img
          v-if="hidden"
          @click="toggleEyeIcon"
          :src="require(`@/` + eyeOpen)"
        />
        <img v-else @click="toggleEyeIcon" :src="require(`@/` + eyeClosed)" />
      </div>
    </div>
    <div class="errorWrapper" :style="{ '--label-height': `${labelHeight}px` }">
      <span class="error-text">{{ data.error }}</span>
    </div>
  </div>
</template>

<script>
import { sendAnalytics } from '../../shared/analytics';

export default {
  name: 'TextInput',
  props: ['text', 'labelKey', 'data', 'icon', 'reducer', 'analyticsPermitted'],

  data() {
    return {
      labelHeight: 0,
      focused: false,
      hidden: true,
      eyeClosed: 'assets/registerPage/eye-closed.svg',
      eyeOpen: 'assets/registerPage/eye-open.svg',
    };
  },
  methods: {
    sendToGA() {
      // if user has already focused on text input then don't send to analytics again
      if (this.focused) {
        return;
      }
      // User has focused once. After this we don't run it again
      this.focused = true;
      // analytics have not been permitted
      if (!this.analyticsPermitted) {
        return;
      }

      sendAnalytics('text_input', {
        title: `signup:${this.data.label}`,
      });
    },
    toggleEyeIcon() {
      this.hidden = !this.hidden;
    },
    inputType() {
      if (this.icon) {
        // if true then show password text
        return this.hidden ? this.data.type : 'text';
      }
      return this.data.type;
    },
  },
  mounted() {
    // measure height of label and apply to error box
    if (this.$refs.labelRef) {
      this.labelHeight = this.$refs.labelRef.offsetHeight;
    }
  },
};
</script>

<style scoped>
.errorWrapper {
  height: var(--label-height);
}
.error-text {
  color: #f15c5e;
  font-family: Lato, sans-serif;
}
/*
==================================
Styles for both Mobile and Desktop
==================================
*/
.reg-input-parent {
  position: relative;
  --reg-title-f-size: 14px;
  font-family: Lato, sans-serif;
  font-size: var(--reg-title-f-size);

  margin-bottom: 6px;
}
.reg-label {
  color: #a1b1b5;
}
.reg-input {
  color: #2b4047;
  width: 100%;
  padding: 1em;
  border: 1px solid transparent;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  height: 50px;
}

.reg-input-parent[data-state='default'] .reg-input {
  border-color: transparent;
}
.reg-input-parent[data-state='active'] .reg-input {
  border-color: #ffdf22;
}
.reg-input-parent[data-state='error'] .reg-input {
  border-color: #f15c5e;
}
.reg-input-parent[data-state='default'] .reg-input:focus {
  border-color: #ffdf22;
}
.register-icon-wrapper {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translate(-50%, -50%);
}

/*
=============
   Desktop
=============
 */

@media (min-width: 1024px) {
  .reg-input-parent {
    --reg-title-f-size: 16px;
  }
}
.input-wrapper {
  position: relative;
}
</style>
